import {createRouter} from '@/router/index.js'
import {pushLogin} from '@/router/util.js'
import axios from 'axios'

export const HTTP_REQUEST_METHOD = {
  GET: 'get',
  POST: 'post',
  DELETE: 'delete',
  HEAD: 'head',
  OPTIONS: 'options',
  PUT: 'put',
  PATCH: 'patch',
}

export const HTTP_REQUEST_HEADER_NAME = {
  CONTENT_TYPE: 'Content-Type',
}

export const HTTP_MIME = {
  JSON: 'application/json',
}

const axiosInstance = axios.create({
  headers: {
    [HTTP_REQUEST_HEADER_NAME.CONTENT_TYPE]: HTTP_MIME.JSON,
  },
})

axiosInstance.interceptors.request.use(config => {
  console.debug('request: ', config)
  return config
})

axiosInstance.interceptors.response.use(res => {
  console.debug('response: ', res)
  const serviceRes = res.data
  if (serviceRes.status < 200 || serviceRes.status >= 300) {
    if (serviceRes.status === 401) {
      const router = createRouter()

      if (router.currentRoute.meta.isAuth) {
        pushLogin(() => router.push('/login'))
      }
    }

    if (serviceRes.status >= 400 && serviceRes.status < 500) {
      return Promise.reject({
        ...serviceRes,
        res,
        type: 'failure',
      })
    }

    if (serviceRes.status >= 500 && serviceRes.status < 600) {
      return Promise.reject({
        ...serviceRes,
        res,
        type: 'error',
      })
    }
  }

  return {
    ...serviceRes,
    res,
  }
}, res => {
  console.debug('response err: ', res)
  return Promise.reject({
    res,
    type: 'error',
  })
})

export function request(config) {
  return axiosInstance(config)
}

export function getRequest(url, params = {}, config = {}) {
  return request({
    ...config,
    url,
    params,
    method: HTTP_REQUEST_METHOD.GET,
  })
}

export function postRequest(url, data = {}, config = {}) {
  return request({
    ...config,
    url,
    method: HTTP_REQUEST_METHOD.POST,
    data,
  })
}
